module.exports = __webpack_public_path__ + "static/media/CentroMedicoSantaRita.2de9106c.svg";